import {KennethMustDie} from "../KennethMustDie";
import {SPECIAL_SYMBOL_NAMES} from "../server/IKMDData";
import {KMDGameMode} from "../server/KMDGameMode";
import {KMDSymbol} from "../reels/KMDSymbol";
import {KMDGameAssets} from "../KMDGameAssets";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {KMDSound} from "../sound/KMDSound";

export class KMDStickyXNudges extends PIXI.Container {

    private _xNudges: PIXI.spine.Spine[][];
    private _xNudgesMultipliers: PIXI.BitmapText[][];
    private _locks: PIXI.spine.Spine[][];
    private _locksPosition: number[] = [25, 75, 150]; // 0 index is for 200 height of lock

    constructor() {
        super();
        this.name = "KMDStickyXNudges";

        this.createItems();
    }

    public showStickyXNudge(reelId: number, symId: number): void {
        // no sticky xNudge during normal or normal_avalanche mode, FS or FS_avalanche
        const mode: string = KennethMustDie.model.data.mode;
        if (mode.indexOf("NORMAL") > -1 || mode === KMDGameMode.FREESPIN || mode === KMDGameMode.FREESPIN_AVALANCHE) {
            return;
        }

        const xNudge: PIXI.spine.Spine = this._xNudges[reelId][symId - 1],
            xNudgeMultiplier: PIXI.BitmapText = this._xNudgesMultipliers[reelId][symId - 1],
            animName: string = "up_" + symId + "_step_nowin",
            animDuration: number = xNudge.skeleton.data.findAnimation(animName).duration;

        if (!xNudge || xNudge.visible) {
            return;
        }

        xNudge.visible = true;
        xNudge.updateTransform();
        xNudge.state.setAnimation(0, animName, false).trackTime = animDuration;

        xNudgeMultiplier.text = "x" + KennethMustDie.model.data.stickyNudgeMultiplier[reelId];
        xNudgeMultiplier.y = (((symId - 1) * KennethMustDie.SYMBOL_HEIGHT) + KennethMustDie.SYMBOL_HEIGHT / 2 + xNudgeMultiplier.height / 2);
        xNudgeMultiplier.visible = true;

        // making sure that the other sticky xNudge on same reel is not visible at same time.
        if (symId === 2) {
            this.hideStickyXNudge(reelId, 0);

            const lock: PIXI.spine.Spine = this._locks[reelId][0];
            lock.state.clearTracks();
            lock.visible = false;
            lock.skeleton.setToSetupPose();
        }

        this.lockXNudge(reelId, symId);

        // making the reel spin sym to be non xNudge symbol, if full reel is sticky then no need to do following action
        if (symId === 1) {
            while (symId > -1) {
                const randomLowName: string = ArrayHelper.getRandomValue(KennethMustDie.LOW_SYMBOL_NAMES),
                    spinOutSym: KMDSymbol = (KennethMustDie.reelView.reelModels[reelId].getStopSymbolAt(symId).positionable as KMDSymbol);
                spinOutSym.updateTexture(randomLowName, 1);
                spinOutSym.visible = true;

                symId--;
            }
        }
    }

    public changeToReelSymbol(reelId: number): void {
        // no sticky xNudge during normal or normal_avalanche mode, FS or FS_avalanche
        const mode: string = KennethMustDie.model.data.mode;
        if (mode.indexOf("NORMAL") > -1 || mode === KMDGameMode.FREESPIN || mode === KMDGameMode.FREESPIN_AVALANCHE) {
            return;
        }

        this._xNudges[reelId].forEach((xNudge: PIXI.spine.Spine, symId: number) => {
            if (xNudge.visible) {
                this.updateReelSymbol(reelId, symId);

                this.hideStickyXNudge(reelId, symId);
            }
        });
    }

    public changeLockSize(reelId: number, symId: number): void {
        const newSize: number = (symId === 0 ? 200 : 300),
            lock: PIXI.spine.Spine = this._locks[reelId][symId];

        lock.skeleton.setToSetupPose();

        lock.name = "locked_" + newSize;

        lock.state.setAnimation(0, lock.name, true);
        lock.y = ((newSize === 200) ? this._locksPosition[0] : this._locksPosition[1]);
    }

    public hideAllStickyXNudges(): void {
        this._xNudges.forEach((items: PIXI.spine.Spine[], reelId: number) => {
            items.forEach((item: PIXI.spine.Spine, symId: number) => {
                if (item.visible) {
                    this.updateReelSymbol(reelId, symId);
                }
                this.hideStickyXNudge(reelId, symId);

                this.unlockXNudge(reelId, symId);
            });
        });
    }

    public checkIfSticky(reelId: number, symId: number): boolean {
        if (symId === 0) {
            return false;
        }

        return (this._locks[reelId] && this._locks[reelId].length > 0 && this._locks[reelId][symId - 1].visible);
    }

    public unlockXNudge(reelId: number, symId: number): void {
        const lock: PIXI.spine.Spine = this._locks[reelId][symId];

        if (!lock || !lock.visible) {
            return;
        }

        lock.state.clearTracks();

        // #480
        KennethMustDie.soundPlayer.playSound(KMDSound.CHAINED_UNLOCKED);

        KennethMustDie.createTimelineForAnimation(lock, 0, lock.name + "_disappear", false).eventCallback("onComplete", () => {
            lock.visible = false;

            lock.skeleton.setToSetupPose();
        });
    }

    private lockXNudge(reelId: number, symId: number): void {
        const lock: PIXI.spine.Spine = this._locks[reelId][symId - 1],
            animNameHelper: string = (symId === 1 ? "300" : "450");

        if (!lock) {
            return;
        }

        lock.name = "locked_" + animNameHelper;
        lock.y = ((symId === 1) ? this._locksPosition[1] : this._locksPosition[2]);

        if (lock.visible) {
            lock.state.setAnimation(0, lock.name, true);

            return;
        }

        lock.visible = true;
        lock.updateTransform();
        KennethMustDie.createTimelineForAnimation(lock, 0, lock.name + "_start", false).eventCallback("onComplete", () => {
            lock.autoUpdate = true;

            lock.state.setAnimation(0, lock.name, true);
        });
    }

    private hideStickyXNudge(reelId: number, symId: number): void {
        this._xNudges[reelId][symId].visible = false;
        this._xNudges[reelId][symId].state.clearTracks();

        this._xNudgesMultipliers[reelId][symId].visible = false;
        this._xNudgesMultipliers[reelId][symId].text = "";
    }

    private updateReelSymbol(reelId: number, symId: number): void {
        symId += 1;

        const isAvalanche: boolean = KennethMustDie.model.gameData.mode.indexOf("AVALANCHE") > -1,
            sym: KMDSymbol = (KennethMustDie.reelView.reelModels[reelId].getStopSymbolAt((symId + (isAvalanche ? 0 : 1))).positionable as KMDSymbol),
            animName: string = "up_" + symId + "_step_nowin";

        sym.originalName = SPECIAL_SYMBOL_NAMES.X_NUDGE_WILD;
        sym.updateAnimation(SPECIAL_SYMBOL_NAMES.X_NUDGE_WILD);
        sym.setState(animName).totalProgress(1);
        sym.removeMultiplierOnXNudge();
        sym.showMultiplierOnXNudge(+(this._xNudgesMultipliers[reelId][symId - 1].text.split("x")[1]), -1);

        // make all above symbols hidden in the reel, as they are NW, and we shouldn't show their win animation
        if (!isAvalanche) {
            symId += 1;
        }
        for (let ctr: number = (symId - 1); ctr > (isAvalanche ? -1 : 0); ctr--) {
            (KennethMustDie.reelView.reelModels[reelId].getStopSymbolAt(ctr).positionable as KMDSymbol).visible = false;
        }
    }

    private createItems(): void {
        const totalRows: number = 2;
        this.y = KennethMustDie.MAIN_REELS_TOP;

        this._xNudges = [];
        this._xNudges.push([]);

        this._xNudgesMultipliers = [];
        this._xNudgesMultipliers.push([]);

        this._locks = [];
        this._locks.push([]);

        // only in middle 3 main reels
        for (let reelId: number = 1; reelId < KennethMustDie.REELS_NUM - 1; reelId++) {
            this._xNudges.push([]);
            this._xNudgesMultipliers.push([]);
            this._locks.push([]);

            for (let symId: number = 1; symId <= totalRows; symId++) {
                const xNudge: PIXI.spine.Spine = new PIXI.spine.Spine(KennethMustDie.assetLoader.getSpineAsset(SPECIAL_SYMBOL_NAMES.X_NUDGE_WILD)),
                    lock: PIXI.spine.Spine = new PIXI.spine.Spine(KennethMustDie.assetLoader.getSpineAsset("locks"));

                xNudge.visible = lock.visible = false;
                xNudge.position.set(((reelId * KennethMustDie.SYMBOL_WIDTH) + KennethMustDie.SYMBOL_WIDTH / 2), (symId * KennethMustDie.SYMBOL_HEIGHT));

                lock.x = xNudge.x;

                this._xNudges[reelId].push(xNudge);
                this._locks[reelId].push(lock);

                const multiplier: PIXI.BitmapText = new PIXI.BitmapText("", {
                    fontName: KMDGameAssets.BITMAP_FONT_WIN_CAP,
                    fontSize: 24
                });
                multiplier.visible = false;
                multiplier.anchor = new PIXI.Point(0.5, 0.5);
                multiplier.x = xNudge.x;
                this._xNudgesMultipliers[reelId].push(multiplier);

                this.addChild(xNudge, multiplier, lock);
            }
        }

        this._xNudges.push([]);
        this._xNudgesMultipliers.push([]);
        this._locks.push([]);
    }
}